/** Formatadores locais de Relatórios > Navegação. */
const NUM = new Intl.NumberFormat('pt-BR');

export const fmtNav = {
    num: (v: number | null | undefined) => NUM.format(v || 0),
    pct1: (v: number | null | undefined) => (v == null ? '—' : `${v.toFixed(1).replace('.', ',')}%`),
    /** UTM vazia no ms-pageview vem null/"" — mostra "(vazio)" para a linha não parecer quebrada. */
    utm: (v: string | null | undefined) => (v && v.trim() ? v : '(vazio)'),
    /** Rótulo de hora: "07h". */
    hour: (h: number) => `${String(h).padStart(2, '0')}h`,
};
